import { Download } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import type { ModalType } from "../../pages/UsersPage";

interface UsersHeaderProps {
  onClick: (modalType: ModalType["modalType"]) => void;
}

export function UsersHeader({ onClick }: UsersHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-3xl font-bold text-gray-900">Пользователи</h1>
      <Button
        variant="outline"
        className="gap-2"
        onClick={() => onClick("create")}
      >
        <Download className="w-4 h-4" />
        Добавить пользователя
      </Button>
    </div>
  );
}
